<template>
  <div class="">
    <div class="w-100 h-100">
      <Nav :rolname="rolname" />
    </div>
    <div class="content" style="background: white">
      <Home
        v-if="page == 'home' && verifBead == true"
        @changePage="changePage"
        @mtdBackCampus="mtdBackCampus"
        :permiso="permiso"
      />
      <Open
        :boxes="boxes"
        v-if="verifBead == false"
        @mtdOpen="mtdOpen"
        @mtdBackCampus="mtdBackCampus"
      />
      <Recetas
        v-if="page == 'recetas'"
        @returnHome="returnHome"
        @devoluciones="devoluciones"
      />
      <Directa
        v-if="page == 'directa'"
        @returnHome="returnHome"
        @changePageVen="changePageVen"
      />
      <Venta
        v-if="page == 'venta'"
        @returnHome="returnHome"
        :bead="bead"
        :client="client"
        @mtdCommitPayment="mtdCommitPayment"
        @changePageVen="changePageVen"
      />
      <Devoluciones
        v-if="page == 'return'"
        @returnHome="returnHome"
        :devolutions="devolutions"
        :subpage="subpage"
        :dataPatient="dataPatient"
        :initial_patient_search="dataPatient.patient_search || ''"
      />
      <DevolucionesAlta
        v-if="page == 'returnAlta'"
        @returnHome="returnHome"
        :initial_patient_id="dataPatient.patient_id || 0"
        :initial_medical_act_id="dataPatient.medical_act_id || 0"
        :initial_patient_search="dataPatient.patient_search || ''"
      />
      <Inventario v-if="page == 'inventario'" @returnHome="returnHome" />
      <Mantenimiento v-if="page == 'maintenance'" @returnHome="returnHome" />
      <Movimiento v-if="page == 'movement'" @returnHome="returnHome" />
      <HistoMov v-if="page == 'histoMov'" @returnHome="returnHome" />
      <RegRecipe
        v-if="page == 'regRecipe'"
        @returnHome="returnHome"
        @mtdChangePage="changePage"
      />
      <Kardex v-if="page == 'kardex'" @returnHome="returnHome" />
      <ConsumosVue v-if="page == 'consumos'" @returnHome="returnHome" />
      <ReporteDespachoVue v-if="page == 'reporte_despacho'" @returnHome="returnHome" />
      <Psicotropicos v-if="page == 'psicotropicos'" @returnHome="returnHome" />
      <Verificacion v-if="page == 'verificacion'" @returnHome="returnHome" @mtdChangePage="mtdChangePage" />
    </div>

    <div class="footer">
      <FooterVue
        v-if="verifBead == true"
        @changePage="changePage"
        :pageView="page"
        :notification-count="unreadCount"
      />
    </div>

    <!-- ============================================================
         NOTIFICACIONES — TOASTS FLOTANTES
         ============================================================ -->
    <template>
      <div>
        <div class="toast-container position-fixed top-0 end-0 p-3">
          <div
            class="toast mb-2"
            :id="'liveToast' + item.id"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            ref="toastElement"
            v-for="(item, index) in notifications"
            :key="index"
          >
            <div class="toast-header">
              <strong class="me-auto color-main">
                <i class="fa fa-bell"></i> DEVOLUCIONES N° {{ index + 1 }}
              </strong>
              <small class="text-body-secondary">Hace {{ item.time }}</small>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
            <div class="toast-body rounded-bottom text-xs bg-light-blue">
              <p class="fw-semibold mb-0">HOLA {{ user }}:</p>
              <div v-html="item.message"></div>
              <button
                class="btn btn-sm btn-success mt-2 w-100"
                @click.stop="mtdDevolver(item)"
              >
                <i class="fas fa-undo"></i> Devolver
              </button>
            </div>
          </div>

          <div
            class="toast align-items-center text-bg-info border-0"
            id="msg"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div class="d-flex">
              <div class="toast-body fw-bold">
                + {{ diff }} devoluciones mas.
              </div>
              <button
                type="button"
                class="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- campana flotante -->
    <div
      style="
        position: fixed;
        top: 90%;
        transform: translateY(-50%);
        right: 20px;
      "
    >
      <button
        class="btn btn-secondary rounded-circle text-md"
        title="Devoluciones"
        type="button"
        data-bs-toggle="offcanvas"
        @click="mtdHiddenNotification(0)"
        data-bs-target="#offcanvasScrolling"
        aria-controls="offcanvasScrolling"
        data-bs-placement="top"
      >
        <i class="fa fa-bell"></i>
      </button>
      <span
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
        v-if="unreadCount > 0"
      >
        {{ unreadCount }}
        <span class="visually-hidden">unread messages</span>
      </span>
    </div>

    <!-- OFFCANVAS — LISTA DE NOTIFICACIONES -->
    <div
      class="offcanvas offcanvas-end"
      data-bs-scroll="true"
      tabindex="-1"
      id="offcanvasScrolling"
      aria-labelledby="offcanvasScrollingLabel"
    >
      <div class="offcanvas-header border">
        <h5 class="offcanvas-title" id="offcanvasRightLabel">Devoluciones</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <div class="border border-main p-2">
          <div class="home__wait-div">
            <div class="row my-1">
              <div
                class="col-md-12 mt-2"
                v-for="(item, index) in notificationsCanvas"
                :key="index"
              >
                <div class="card div-pointer">
                  <div
                    class="card-header text-xs"
                    :class="item.state == 1 ? 'bg-title-blue' : ''"
                  >
                    <div class="">
                      <strong>N° {{ index + 1 }} - Hace {{ item.time }}</strong>
                    </div>
                  </div>
                  <div
                    class="card-body text-xs"
                    :class="item.state == 1 ? 'bg-light-blue' : 'bg-white'"
                  >
                    <p class="card-text mb-1" v-html="item.message"></p>
                    <small
                      v-if="item.state == 2"
                      class="fst-italic text-success"
                      >{{ item.time_read }}</small
                    >
                    <button
                      class="btn btn-sm btn-success mt-2 w-100"
                      @click.stop="mtdDevolver(item)"
                    >
                      <i class="fas fa-undo"></i> Devolver
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-if="notificationsCanvas.length == 0"
                class="text-center py-5"
              >
                <strong>No hay devoluciones actualmente</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Nav from "../../components/QuimicoFarmaceutico/Nav.vue";
import FooterVue from "../../components/QuimicoFarmaceutico/Footer.vue";
import Home from "../../components/QuimicoFarmaceutico/Home.vue";
import Kardex from "../../components/QuimicoFarmaceutico/pages/Kardex.vue";

/* Páginas compartidas con Farmacia (mismo backend, sin branding propio) */
import Open from "@/components/Admision/pages/Open.vue";
import Recetas from "@/components/Farmacia/pages/Reci.vue";
import Directa from "@/components/Farmacia/pages/Directa.vue";
import Venta from "@/components/Farmacia/pages/Venta.vue";
import Devoluciones from "@/components/Farmacia/pages/Dev.vue";
import Inventario from "@/components/Farmacia/pages/Inventory.vue";
import Mantenimiento from "@/components/Farmacia/pages/Maintenance.vue";
import Movimiento from "@/components/Farmacia/pages/Movimiento.vue";
import HistoMov from "@/components/Farmacia/pages/HistoMov.vue";
import RegRecipe from "@/components/Farmacia/pages/RegRecipe.vue";
import ConsumosVue from "@/components/Farmacia/pages/Consumos.vue";
import ReporteDespachoVue from "@/components/Farmacia/pages/ReporteDespacho.vue";
import DevolucionesAlta from "@/components/Farmacia/pages/DevolucionesAlta.vue";
import Psicotropicos from "@/components/QuimicoFarmaceutico/pages/Psicotropicos.vue";
import Verificacion from "../../components/Logistica/pages/VerificacionStock.vue";


export default {
  name: "QuimicoFarmaceuticoView",
  components: {
    Nav,
    FooterVue,
    Home,
    Kardex,
    Open,
    Recetas,
    Directa,
    Venta,
    Devoluciones,
    Inventario,
    Mantenimiento,
    Movimiento,
    HistoMov,
    RegRecipe,
    ConsumosVue,
    ReporteDespachoVue,
    DevolucionesAlta,
    Psicotropicos,
    Verificacion,
  },
  data() {
    return {
      prefix: "Pharmacy",
      area: "QuimicoFarmaceutico",
      bead: {},
      verifBead: true,
      boxes: [],
      page: "home",
      client: null,
      close: 0,
      user: "",
      devolutions: null,
      notifications: [],
      notificationsCanvas: [],
      diff: 0,
      subpage: "",
      dataPatient: {},
      filter: {},
      permiso: false,
    };
  },
  props: {
    rolname: String,
  },
  computed: {
    unreadCount() {
      if (!this.notificationsCanvas || !Array.isArray(this.notificationsCanvas))
        return 0;
      return this.notificationsCanvas.filter((n) => n.state === 1).length;
    },
  },
  created() {
    this.rol_name = this.rolname;
    this.user = this.$store.getters.get__user.name;
    this.mtdGetPermiso();
  },
  mounted() {
    this.mtdGetNotificatons();
    this.mtdGetAllNotifications();
  },
  watch: {
    page(newValue) {
      this.mtdGetAllNotifications();
      if (newValue == "home") {
        this.mtdGetNotificatons();
      } else {
        this.mtdHiddenNotification();
      }
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    changePageVen: function (page, client) {
      this.client =
        page == "venta" ? client : page == "home" ? this.client : null;
      this.page = page;
    },
    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    devoluciones: function (payload) {
      this.devolutions = payload;
      this.page = "return";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdCommitPayment: function (res) {
      this.bead = res;
      this.page = "directa";
    },
    mtdOpen: function (data) {
      this.verifBead = true;
      this.page = "home";
      this.bead = data;
    },

    // Notificaciones
    mtdGetNotificatons: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/returns/notifications/0",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let notifications = response.data;
          this.notifications = notifications.slice(0, 3);
          this.diff = notifications.length - this.notifications.length;
          this.$nextTick(() => {
            this.notifications.forEach((element) => {
              const toastElement = document.getElementById(
                "liveToast" + element.id
              );
              if (toastElement) {
                const toast = new bootstrap.Toast(toastElement, {
                  autohide: false,
                });
                toast.show();
              }
            });
            if (notifications.length > 3) {
              const toastElementMsg = document.getElementById("msg");
              if (toastElementMsg) {
                const toast = new bootstrap.Toast(toastElementMsg, {
                  autohide: false,
                });
                toast.show();
              }
            }
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    mtdDevolver(item) {
      this.dataPatient = {
        patient_id: item.patient_id,
        medical_act_id: item.medical_act_id,
        patient_search: item.patient_document || item.patient_name || "",
      };

      if (item.is_discharged === true) {
        this.page = "returnAlta";
      } else {
        this.page = "return";
        this.subpage = "dev-" + item.id;
      }

      this.viewAndClose();
      this.updateState(item);
    },

    viewAndClose() {
      let offcanvasElement = document.getElementById("offcanvasScrolling");
      let offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (offcanvasInstance) {
        offcanvasInstance.hide();
      }
    },

    updateState(item) {
      if (item.state == 1) {
        this.post({
          url:
            this.$store.getters.get__url +
            "/" +
            this.prefix +
            "/returns/notifications/update",
          token: this.$store.getters.get__token,
          params: { id: item.id },
        })
          .then((response) => {
            this.mtdGetAllNotifications();
            Swal.fire({
              icon: "success",
              title: "Notificacion Leida",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((errors) => {
            console.log(errors);
          });
      }
    },

    mtdHiddenNotification(option) {
      this.notifications = [];
      const toastElementMsg = document.getElementById("msg");
      if (toastElementMsg) {
        const toast = new bootstrap.Toast(toastElementMsg, {
          autohide: false,
        });
        toast.hide();
      }
      if (option == 0) {
        this.mtdGetAllNotifications();
      }
    },

    mtdGetAllNotifications: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/returns/notifications/1",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.notificationsCanvas = response.data;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    mtdGetPermiso: function () {
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix + "/permisos",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.permiso = response.permission == 0 ? false : true;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
  },
};
</script>